import styled from 'styled-components';

import { nepal } from '@paradigm/design-system/src/colors';

const Label = styled.label`
  color: ${nepal};
  margin-bottom: 0.1rem;
  flex: 1;
`;

export default Label;
